// Implements: F-SHR-003
/**
 * The link the person copies, as an absolute URL.
 *
 * The server answers the URL prefixed by `SHARE_PUBLIC_BASE_URL` when one is
 * configured, and the bare path (`/api/share/...`) when it is not (SA9). A bare
 * path pasted into a chat opens nothing, so the SPA prefixes the origin it is
 * served from, which is the origin the API answers on (OD-2).
 */
export function absoluteShareUrl(url: string, origin: string): string {
  return url.startsWith("/") ? `${origin}${url}` : url;
}
